import { FormattedMessage } from 'react-intl';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import type { IneligibleOpening } from './types';

interface PostingUnavailableDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ineligibleOpenings: IneligibleOpening[];
}

/**
 * Dialog shown when a user tries to post ineligible openings to job boards.
 * When count is 1: shows message based on reason (inactive vs sourcing_disabled).
 * When count > 1: shows generic message.
 */
export function PostingUnavailableDialog({
  open,
  onOpenChange,
  ineligibleOpenings,
}: PostingUnavailableDialogProps) {
  const count = ineligibleOpenings.length;
  const isSingle = count === 1;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[320px] gap-0 p-0">
        <AlertDialogHeader className="p-4 pb-0 text-left">
          <AlertDialogTitle className="text-fx-neutral-900">
            <FormattedMessage defaultMessage="Can't Post to Job Boards" />
          </AlertDialogTitle>
          <AlertDialogDescription className="text-fx-neutral-600 flex flex-col gap-2 pt-2">
            {isSingle ? (
              <FormattedMessage defaultMessage="This opening isn't eligible for posting. Check that it's active and sourcing is enabled." />
            ) : (
              <FormattedMessage defaultMessage="None of the selected openings are eligible for posting. Check that each is active and sourcing is enabled." />
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-row justify-between gap-2 border-0 p-4">
          <AlertDialogCancel className="m-0">
            <FormattedMessage defaultMessage="Cancel" />
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
